import { Component } from '@angular/core';

@Component({
  selector: 'app-customers-count',
  imports: [],
  templateUrl: './customers-count.html',
})
export class CustomersCount {}
